<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g id="icon">
      <path
        d="M2.5,8.5v9c0,0.55,0.45,1,1,1h14c0.55,0,1,-0.45,1,-1v-9"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5,4.5l1.5,4h15l1.5,-4H1.5z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6,8.5c0,1.1,-0.9,2,-2,2s-2,-0.9,-2,-2"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5,8.5c0,1.1,-0.9,2,-2,2s-2,-0.9,-2,-2"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15,8.5c0,1.1,-0.9,2,-2,2s-2,-0.9,-2,-2"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19,8.5c0,1.1,-0.9,2,-2,2s-2,-0.9,-2,-2"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="8"
        y="13.5"
        width="5"
        height="5"
        rx="0.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
